import { SettingsService } from '../settings.service';
import { TipoTelefone } from './modelos/tipo-telefone';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ComumHttpService {

  private _host: string;

  constructor(private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase();
  }

  obterTiposTelefoneHttp(): Observable<TipoTelefone[]> {
    return this._http.get(this._host + '/usuarios/tipos-telefone')
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/comum-http.service.ts